<div class="container d-flex justify-content-center align-items-center pt-5">
    <div class="text-center">
        <h1 class="display-4 text-danger">Access Denied</h1>
        <p class="lead">You do not have permission to view this page.</p>
        <div class="alert alert-danger" role="alert">
            Your access has been restricted. Please contact the administrator if you believe this is a mistake.
        </div>
        <a href="/" class="btn btn-primary mt-3">Return to Home</a>
    </div>
</div>